import { render, staticRenderFns } from "./ExamFreedomAnalysis.vue?vue&type=template&id=3ab3d184"
import script from "./ExamFreedomAnalysis.vue?vue&type=script&lang=js"
export * from "./ExamFreedomAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports